export const ROOM_REFINEMENTS = [
  'bathroom',
  'bedroom',
  'closet',
  'dining-room',
  'dorm-room',
  'entryway',
  'garage',
  'home-office',
  'kids-room',
  'kitchen',
  'laundry-room',
  'living-room',
  'outdoor',
  'workshop'
];
export const STYLE_REFINEMENTS = [
  'art-deco',
  'bohemian',
  'classic',
  'coastal',
  'cottage',
  'farmhouse',
  'glam',
  'holiday',
  'industrial',
  'mid-century-modern',
  'mission', 'modern',
  'rustic', 'southwest',
  'southwestern',
  'vintage'
];
export const COLOR_REFINEMENTS = [
  'aqua',
  'beige',
  'black',
  'blue',
  'blush',
  'brown',
  'copper',
  'cream',
  'gold',
  'gray',
  'green',
  'orange',
  'pink',
  'purple',
  'red',
  'silver',
  'sky',
  'tan',
  'white',
  'wood',
  'yellow'
];

export const ROOM_KEY = 'room';
export const COLOR_KEY = 'color';
export const STYLE_KEY = 'style';
export const PAGE_KEY = 'Nao';

export const NUMBER_OF_RESULTS = 24;
export const FIRST_PAGE = 1;

export const MOBILE_CHANNEL = 'mobile';
